import { useTranslation } from 'react-i18next';
import { canManageSpace, type Space } from '../model';
import { MembersPanel } from './members-panel';
import { SharingSection } from './sharing-ui';

/**
 * The People tab: everyone with access to the space, from the host and from partner organisations,
 * with how each person got in. Removal and the 90-day extension of a guest are the managers'.
 */
export function SpacePeopleTab({ space }: { space: Space }) {
  const { t } = useTranslation('spaces');
  return (
    <SharingSection
      id="people-list"
      title={t('sharing.people.heading')}
      description={t('sharing.people.description')}
    >
      <MembersPanel
        space={space}
        showOrganisation
        allowExtend={canManageSpace(space)}
        emptyTitle={t('sharing.people.emptyTitle')}
        emptyBody={t('sharing.people.emptyBody')}
      />
    </SharingSection>
  );
}
